export const getEcuadorTime = (): string => {
  const options: Intl.DateTimeFormatOptions = {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    timeZone: 'America/Guayaquil',
  }
  return new Date().toLocaleTimeString('en-US', options)
}